<template>
  <div class="cadastro-usuario">
    <v-container fluid>
      <BrAppBar>
        <h1 class="titulo">{{ $t('clientes.title') }}</h1>
      </BrAppBar>


      <div class="box-table box-table-gecom">
        <!-- <v-skeleton-loader :loading="loadingTable" :transition="'fade-transition'" height="500" type="table"> -->
        <v-data-table class="mt-4" :headers="headers" :search="search" :items="listaItens" width="300px" flat
          :expanded.sync="expanded" v-model="selected" hide-default-footer :loading="loadingTable" :show-select="false"
          :items-per-page.sync="itemsPerPage" :mobile-breakpoint="0">
          <template v-slot:top>
            <v-row justify="space-between" class="px-3 mb-2 top-table">
              <v-col cols="12" md="3" class="order-md-1 order-2">
                <!-- <DateModal :dates.sync="data" :maxDateRange="30" /> -->
                <div class="container-filters d-flex align-center">
                  <div>
                    <span class="filter-data-span mr-2">{{ $t('common.period') }}: </span>
                  </div>
                  <div class="w-50">
                    <OrganizzeCalendar class="pb-3" :dateWidth="270" :dense="true" rounded></OrganizzeCalendar>
                  </div>
                </div>
              </v-col>

              <v-col cols="11" md="3" class="order-md-2 order-1">
                <v-text-field hide-details="auto" dense outlined prepend-inner-icon="mdi-magnify" :placeholder="$t('common.search')"
                  class="search-button" v-model="textSearch" v-on:keyup.enter="buscar(textSearch)"></v-text-field>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.created="{ item }">
            {{ item.created }}
          </template>

          <!-- <template v-slot:item.despesas="{ item }">
              {{ item.despesas | currency }}
            </template>

            <template v-slot:item.depositoLiquido="{ item }">
              {{ item.depositoLiquido | currency }}
            </template>

            <template v-slot:item.receitaLiquida="{ item }">
              {{ item.receitaLiquida | currency }}
            </template>

            <template v-slot:item.bonus_convertidos="{ item }">
              {{ item.bonus_convertidos | currency }}
            </template>

            <template v-slot:item.retiradas="{ item }">
              {{ item.retiradas | currency }}
            </template>

            <template v-slot:item.depositos="{ item }">
              {{ item.depositos | currency }}
            </template>

            <template v-slot:item.apostas="{ item }">
              {{ item.apostas | currency }}
            </template>

            <template v-slot:item.ganhos="{ item }">
              {{ item.ganhos | currency }}
            </template>

            <template v-slot:item.jogos="{ item }">
              {{ item.jogos | currency }}
            </template> -->


          <template v-slot:footer>
            <div class="wrapper-footer">
              <div class="qtd-paginacao">
                {{ pageStart }}
                -
                {{ pageStop }}
                {{ $t('common.of') }}
                {{ totalItens }}
              </div>
              <v-pagination v-model="page" :length="numberOfPages" circle :disabled="disabled" :total-visible="7"
                class="box-table-paginacao" v-if="numberOfPages > 1"></v-pagination>
            </div>
          </template>
        </v-data-table>
        <!-- </v-skeleton-loader> -->
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { errorSnackbar } from '@/core/service/utils'
import moment from 'moment'
import Events from '@/core/service/events'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'

const namespaceStore = 'afiliadosClientes'

export default {
  name: 'afiliadosClientesPage',
  components: {
    // rangeDate: () => import('../../components/rangeDateParceiros'),
    // DateModal: () => import('./components/dateModal'),
    BrAppBar: () => import('@/views/layout/appBar'),
    OrganizzeCalendar: () => import('@/views/components/organizze/calendar'),
    // ExpansionPanelDefault: () => import('@/views/components/expansionPanelDefault'),
  },
  mixins: [listagemTables],
  watch: {
  },
  data: () => ({
    loading: false,
    loadingFechandoLiquidacoes: false,
    loadingFechamento: false,
    loadingTable: false,
    // data: [moment().add(-7, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    // startDate: moment().add(-7, 'd').format('YYYY-MM-DD'),
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    textSearch: '',
    selected: [],
    expanded: [],
    isOpenModal: false,
    dataContractSettlements: undefined
  }),
  mounted() {
    this.buscar()
    this.init()
    Events.$on('organizzeCalendar::close-on-content-click', this.handleCalendarClose)
  },
  beforeDestroy() {
    Events.$off('organizzeCalendar::close-on-content-click', this.handleCalendarClose);
  },
  computed: {
    ...mapGetters(namespaceStore, ['listaItens', 'totalItens']),
    ...mapGetters('auth', ['user']),

    headers () {
      return [
        { align: 'start', class: 'table-header', text: this.$t('common.id'),   value: 'id' },
        { align: 'start', class: 'table-header', text: this.$t('common.name'), value: 'fullName' },
        { align: 'start', class: 'table-header', text: this.$t('common.date'), value: 'created' },
      ]
    },

    typesInterval() {
      return {
        'DAY': 'Dias'
      }
    }
  },

  methods: {
    ...mapActions(namespaceStore, ['getItens', 'limparTabela', 'fecharLiquidacoes']),

    clearDados() {
      // this.clearItens()
    },

    init() { },

    handleCalendarClose(eventData) {
       if (Math.abs(moment(eventData.startDate).diff(moment(eventData.endDate), 'days')) > 31) {
         errorSnackbar(this.$t('relatorios.rangeDatas'))
         return
       }

      if (this.startDate !== eventData.startDate || this.endDate !== eventData.endDate) {
        this.startDate = eventData.startDate
        this.endDate = eventData.endDate
        this.getData(this.textSearch)
      }
    },

    getData(textSearch = '') {
      this.loadingTable = true
      this.getItens({
        page: this.page,
        dtStart: this.startDate,
        dtEnd: this.endDate,
        pageSize: this.$store.getters.ItensPaginacao,
        textSearch: `%${textSearch}%`
      })
        .catch(err => {
          console.log(err)
          errorSnackbar(err.error)
        })
        .finally(() => this.loadingTable = false)
    },

    buscar(textSearch) {
      this.getData(textSearch)
    },

    paginacao() {
      this.getData()
    },

    limparDados() {
      this.selected = []
      this.limparTabela()
    },

    montarLabelFiltro() {
      Events.$on('autoCompleteEntities::getSearchText', (val) => { this.terminalTextSelected = val })
      let labelFiltro = [
        {
          label: 'Data Inicial:',
          value: moment(this.data[0]).format('DD/MM/YYYY')
        },
        {
          label: 'Data Final:',
          value: moment(this.data[1]).format('DD/MM/YYYY')
        },
      ]
      return labelFiltro
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/components/table';

.v-data-table thead tr th,
.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: $colorPrimary !important;
}

.v-application .top-table {
  align-items: center;

  @media (max-width: 485px) {
    display: flex;
    justify-content: center !important;
  }
}

.search-button {
  @media (max-width: 485px) {
    width: 370px !important;
  }
}

.sub-title {
  color: #7C7C8A;
}

.text-end {
  color: #7C7C8A;
}

.v-data-table thead tr th,
.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: $colorPrimary !important;
}

.box-table {
  .v-data-table-header-mobile {
    display: none;
  }
}

.v-application .top-table {
  margin-bottom: 20px !important;
}

.title {
  color: #FFFF;
}

.search-button {
  border-radius: 8px;
}

.theme--light.v-input input,
.theme--light.v-input textarea,
.theme--light.v-input input,
.theme--light.v-input .i .theme--light.v-input input,
.v-application .primary--text,
.theme--light.v-input ::placeholder {
  color: #7C7C8A !important;
}

.v-text-field {
  border-radius: 8px;
}

.v-text-field--outlined {

  input::placeholder {
    color: #7C7C8A !important;

    i {
      color: #7C7C8A !important;
    }
  }

  input {
    color: #7C7C8A !important;
  }

  i {
    color: #7C7C8A !important;
  }

  /* .v-label {
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.75em;
  } */

  /* .v-label--active {
    transform: translateY(-25px) scale(0.75);
  } */

  fieldset {
    border-radius: 8px;
    border-color: #7C7C8A !important;
    border-width: 1px;
  }

  i {
    color: #7C7C8A !important;
  }
}

.theme--light.v-card {
  background: #1D1D29 !important;
  border-radius: 16px;
}

.card-table {
  background: #1D1D29;
  border-radius: 16px;
}

.theme--light.v-data-table {
  padding-top: 20px !important;
}

i.v-icon.notranslate.sub-title-icon.mdi.mdi-information-outline.theme--light {
  color: #7C7C8A !important;
}
</style>
